import * as React from 'react';
import * as ReactModal from 'react-modal';
import Waypoint from 'react-waypoint';
const ModalContext = React.createContext({
    value: {},
    // tslint:disable-next-line
    onChange: () => { },
});
ReactModal.setAppElement('#___gatsby');
export function ModalsProvider({ modals, children, }) {
    const [value, onChange] = React.useState({});
    const keys = Object.keys(value).filter(key => value[key]);
    return (React.createElement(ModalContext.Provider, { value: { value, onChange } },
        children,
        keys.map(key => {
            const ModalContent = modals[key];
            if (!ModalContent) {
                return null;
            }
            return (React.createElement(ReactModal, { key: key, isOpen: value[key], onRequestClose: () => {
                    onChange({ ...value, [key]: false });
                }, overlayClassName: "fixed absolute--fill flex items-center justify-center z-4 bg-white-50", className: "bg-white shadow-1 pa4 mh3 br3 outline-0" },
                React.createElement(ModalContent, null)));
        })));
}
/*
function checkToShow(id: string) {
}

function saveModalState(id: string, notShowIn: number) {}
*/
export function ModalClickTrigger({ id, className, text, }) {
    return (React.createElement(ModalContext.Consumer, null, ({ value, onChange }) => {
        return (React.createElement("a", { className: className, onClick: () => onChange({ ...value, [id]: true }) }, text));
    }));
}
class Timeout extends React.PureComponent {
    componentDidMount() {
        this.timeout = setTimeout(this.props.trigger, this.props.timeout);
    }
    componentWillUnmount() {
        clearTimeout(this.timeout);
    }
    render() {
        return null;
    }
}
export function ModalTimerTrigger({ id, timeout, }) {
    return (React.createElement(ModalContext.Consumer, null, ({ value, onChange }) => (React.createElement(Timeout, { timeout: timeout, trigger: () => onChange({ ...value, [id]: true }) }))));
}
export function ModalScrollTrigger({ id }) {
    return (React.createElement(ModalContext.Consumer, null, ({ value, onChange }) => (React.createElement(Waypoint, { onEnter: () => onChange({ ...value, [id]: true }) }))));
}
//# sourceMappingURL=index.js.map